// Entfaltet die kompakte Regalgeometrie (data/handregal-geometrie.ts) zu Einzelfaechern.
//
// Warum kompakt gespeichert: 1.941 Einzelsaetze waeren rund 400 KB im Bundle. Ein Block ist
// durch Startnummer, Breite, Hoehe und Richtung vollstaendig bestimmt — 109 Bloecke plus eine
// Spaltenfolge genuegen und bleiben im niedrigen zweistelligen Kilobyte-Bereich.
import type { HandregalAusstattung } from '@/data/handregal-ausstattung'

export interface RegalBlock {
  etage: 'EG' | 'OG'
  band: number
  seite: 'links' | 'rechts'
  block: number
  von: number
  bis: number
  breite: number
  hoehe: number
  /** true = im Plan laufen die Nummern nach RECHTS aufsteigend. Jedes zweite Band ist um 180
   *  Grad gedreht gezeichnet, weil es die Rueckseite desselben Regals zeigt. */
  aufsteigend: boolean
  /** true = ueber dem Band steht BODEN (Durchgang), die oberste gedruckte Zeile ist damit die
   *  UNTERSTE Ebene. false = darueber steht DACH, dann ist es umgekehrt. */
  bodenOben: boolean
  zeile: number
  spalte: number
}

export interface RegalGeometrie {
  stand: string
  quelle: string
  bloecke: RegalBlock[]
  /** Zwei Zeichen je Fachnummer: Spalte (charCode - 64), dann Spannweite 1 oder 2. */
  spalten: string
}

export interface RegalFach {
  nummer: number
  etage: 'EG' | 'OG'
  band: number
  seite: 'links' | 'rechts'
  block: number
  /** 1 = unterste Ebene am Durchgang. */
  ebene: number
  ebenen: number
  /** Position in der GEDRUCKTEN Reihenfolge des Blocks, 1 = links. */
  position: number
  spalte: number
  spannweite: 1 | 2
  ungenutzt: boolean
}

export function entfalteGeometrie(g: RegalGeometrie, a: HandregalAusstattung): RegalFach[] {
  const faecher: RegalFach[] = []
  for (const b of [...g.bloecke, ...a.zusatzBloecke]) {
    for (let i = 0; i < b.hoehe; i++) {
      for (let j = 0; j < b.breite; j++) {
        const versatz = i * b.breite + j
        const nummer = b.aufsteigend ? b.von + versatz : b.bis - versatz
        faecher.push({
          nummer,
          etage: b.etage,
          band: b.band,
          seite: b.seite,
          block: b.block,
          ebene: b.bodenOben ? i + 1 : b.hoehe - i,
          ebenen: b.hoehe,
          position: j + 1,
          spalte: nummer * 2 <= g.spalten.length ? g.spalten.charCodeAt((nummer - 1) * 2) - 64 : b.spalte + j,
          spannweite: nummer * 2 <= g.spalten.length ? Number(g.spalten[(nummer - 1) * 2 + 1]) as 1 | 2 : 1,
          ungenutzt: a.ungenutzt.some(u => nummer >= u.von && nummer <= u.bis),
        })
      }
    }
  }
  return faecher
}
